export function Contact()
{
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 64C14.4 64 0 49.6 0 32S14.4 0 32 0s32 14.4 32 32-14.4 32-32 32zm0-60C16.6 4 4 16.6 4 32s12.6 28 28 28 28-12.6 28-28S47.4 4 32 4z"/><path d="M28 29h8v20h-8z"/><circle cx="32" cy="19" r="4"/></svg>
	);
}

